import React from 'react';
import type { SVGProps } from 'react';

interface TopicIconSvgProps extends SVGProps<SVGSVGElement> {}

export const GriefIcon: React.FC<TopicIconSvgProps> = (props) => (
  <svg viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.6289 1.91355C18.8153 1.91355 19.9332 2.38086 20.7752 3.22887C22.5215 4.98934 22.5215 7.85363 20.7752 9.6141L11.999 18.4608L3.22484 9.6141C1.47847 7.85363 1.47847 4.98934 3.22484 3.22887C4.06479 2.38086 5.18271 1.91355 6.36911 1.91355C7.55552 1.91355 8.67344 2.38086 9.5154 3.22887L10.6414 4.36492L12.001 5.73462L13.3606 4.36492L14.4866 3.22887C15.3266 2.38086 16.4445 1.91355 17.6309 1.91355M17.6289 0C15.9993 0 14.3698 0.626437 13.125 1.88133L11.999 3.01737L10.873 1.88133C9.63021 0.626437 8.00067 0 6.36911 0C4.73756 0 3.11003 0.626437 1.86723 1.88133C-0.622409 4.38909 -0.622409 8.45388 1.86723 10.9616L12.001 21.178L22.1348 10.9616C24.6244 8.45388 24.6244 4.38909 22.1348 1.88133C20.89 0.628452 19.2604 0 17.6309 0L17.6289 0Z"
      fill="currentColor"
    />
  </svg>
);
